import styled from "styled-components";

export const RecentPostsBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f1f5ff;
  padding-top: 110px;
  @media (max-width: 768px) {
    padding-top: 64px;
  }
`;

export const Title = styled.h2`
  margin-bottom: 50px;
  max-width: 340px;
  @media (max-width: 768px) {
    margin-bottom: 35px;
  }
`;

export const PostsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 30px;
  margin-bottom: 60px;
  @media (max-width: 768px) {
    grid-column-gap: 10px;
    margin-bottom: 20px;
  }
`;

const ease = "cubic-bezier(0.2, 0.7, 0.2, 1)";

// A report cover lifting off the shelf: rises, casts a deeper shadow, and a
// band of light sweeps across it.
export const PosterLink = styled.a`
  position: relative;
  display: block;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(2, 32, 60, 0.12);
  transition: transform 0.45s ${ease}, box-shadow 0.45s ${ease};
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(105deg, transparent 35%, rgba(255, 255, 255, 0.45) 50%, transparent 65%);
    transform: translateX(-120%);
    transition: transform 0.8s ${ease};
    pointer-events: none;
  }
  &:hover,
  &:focus-visible {
    transform: translateY(-10px);
    box-shadow: 0 26px 44px rgba(2, 32, 60, 0.28);
  }
  &:hover::after,
  &:focus-visible::after {
    transform: translateX(120%);
  }
  &:focus-visible {
    outline: 3px solid #02c5ff;
    outline-offset: 4px;
  }
  @media (prefers-reduced-motion: reduce) {
    &,
    &::after {
      transition: none;
    }
  }
`;

export const Poster = styled.img`
  display: block;
  width: 100%;
`;
